<template>
    <section class="attestation">
		<van-nav-bar title="身份认证" left-arrow @click-left="backFn" class="top_bar" />	
		<section v-if="status==1"></section>
		<section class="no_over" v-else-if="status==0">
			<div class="inform">
				根据工信部规定要求，为避免可能出现的网络欺诈问题，需要您完成实名和工作认证
			</div>
			<div class="form">
				<van-field v-model="form.name" label="姓名" :left-icon="imgs.nameIcon" placeholder="请输入个人真实姓名" /> 
				<van-field v-model="form.idcard" label="身份证号" :left-icon="imgs.cartIcon" placeholder="请输入个人身份证号" /> 
				<van-field v-model="form.companyName" label="就职公司" :left-icon="imgs.companyIcon" placeholder="请输入就职公司全称" /> 
				 <van-field label="工作城市" :value="form.workRegion" :left-icon="imgs.cityIcon" readonly right-icon="arrow" placeholder="请选择工作城市" @click="isCityModel=true" />
				 <div class="upload_card">
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.idcardFrontUrl" :src="form.idcardFrontUrl" class="oss_img">
							<img v-else :src="imgs.renxiangIcon" class="upload_bg" @click="chooseImg('idcardFrontUrl')">
							<van-icon name="cross" v-if="form.idcardFrontUrl" @click="delImg('idcardFrontUrl')" />
						</div>
						<p class="tit">身份证人像面</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.idcardBackUrl" :src="form.idcardBackUrl" class="oss_img">
							<img v-else :src="imgs.guohuiIcon" class="upload_bg" @click="chooseImg('idcardBackUrl')">
							<van-icon name="cross" v-if="form.idcardBackUrl"  @click="delImg('idcardBackUrl')"/>
							</div>
						<p class="tit">身份证国徽面</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.idcardHoldUrl" :src="form.idcardHoldUrl" class="oss_img">
							<img v-else :src="imgs.shouchiIcon" class="upload_bg" @click="chooseImg('idcardHoldUrl')">
							<van-icon name="cross" v-if="form.idcardHoldUrl" @click="delImg('idcardHoldUrl')" />
						</div>

						<p class="tit">手持身份证照片</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.otherCertUrl" :src="form.otherCertUrl" class="oss_img">
							<img v-else :src="imgs.gongpaiIcon" class="upload_bg" @click="chooseImg('otherCertUrl')">
							<van-icon name="cross" v-if="form.otherCertUrl" @click="delImg('otherCertUrl')" />
						</div>
						<p class="tit">名片/工牌/在职证明</p>
					</div>
				 </div>
			</div>
			<div class="authorization" @click="skipAuthorizationView">查看《个人信息使用授权书》</div>
			<div class="bottom_btn">
				<van-button type="primary" @click="submitForm">同意授权书并开始认证</van-button>
			</div>
		</section>
		<section class="underway" v-else-if="status==10">
			<img src="../../assets/img/underway.png">
			<p>认证中，3个工作日内完成</p>
		</section>
		<section class="pass" v-else-if="status==20">
			<img src="../../assets/img/pass.png">
			<p>身份认证通过</p>
		</section>
		<section class="fail" v-else>
			<img src="../../assets/img/fail.png">
			<p>身份认证失败</p>
			<span v-html="msg" class="msg"></span>
			<van-button round type="danger" class="danger-button" @click="alignFn">重新认证</van-button>
		</section>
		<div class="city_container">
			<van-popup v-model="isCityModel" round position="bottom" class="model_class" >
				<van-area title="请选择" :area-list="areaList" columns-num="2" @cancel="isCityModel=false" @confirm="confirmCity" />
			</van-popup>
		</div>
		<AttestationTxt :isExplain="isExplain" @closeModel="isExplain=false"/>
	</section>
</template>

<script>

import Nav from "components/Nav";
import AttestationTxt from "components/AttestationTxt";
import cityIcon from 'assets/img/city.png'
import companyIcon from 'assets/img/company.png'
import cartIcon from 'assets/img/cart.png'
import nameIcon from 'assets/img/name.png'
import gongpaiIcon from 'assets/img/gongpai.png'
import guohuiIcon from 'assets/img/guohui.png'
import shouchiIcon from 'assets/img/shouchi.png'
import renxiangIcon from 'assets/img/renxiang.png'
import {areaList}  from '@vant/area-data';
import attestationServer from "api/attestation";
import { Notify, Dialog } from 'vant';


export default {
    name: "attestation",
    components: {
        Nav,
		AttestationTxt,
    },
    data() {
        return {
			status: 1,
			imgs: {
				cityIcon,
				companyIcon,
				cartIcon,
				nameIcon,
				gongpaiIcon,
				guohuiIcon,
				shouchiIcon,
				renxiangIcon,
			},
			form:{
				idcardFrontUrl: '',
				idcardBackUrl: '',
				idcardHoldUrl: '',
				otherCertUrl: '',
				idcard: '',
				name: '',
				workRegion: '',
				companyName: '',
			},
			areaList,
			isCityModel: false,
			msg: '',
			isExplain: false,
			isSubmit: true,
		};
    },
    created() {
        Dialog.alert({ title: '抢单App认证暂停', message:'请联系客服开通自动推单'}).then(() => {
            this.$router.push({name:'kefu'})
        })
		this.getInfo()
	},
    methods: {
		//获取认证状态
		getInfo() {
			//未认证 0 认证中 10 认证成功 20 认证失败 30 结果不明 40
			attestationServer.SearchAStatus().then((res) => {
				this.status = res.data.status
				this.msg = res.data.msg.replace(/\n/g, '<br>')
			})
		},
		alignFn() {
			this.status = 0
		},
		chooseImg(type) {
			kk_requestPhotoLibraryAuthorization((res)=>{
				if(res.code == 1) {
					this.chooseLocalityImg(type)
				}else if(res.code == 2) {
					Notify({ type: 'danger', message: '	请选择图片' })
				}else {
					Notify({ type: 'danger', message: '请打开图片权限' })
				}
			});
		},
		chooseLocalityImg(type) {
			kk_chooseImage((res)=>{
				if (res.code == 1){
					var imageBase64 = res.data;
					let file = this.base64ToFile(imageBase64, (new Date()).valueOf())
					this.uploadOss(file, type)
				}
			});
		},
		uploadOss(file, type) {
			if(file.size/1024>5120){
				Notify({ type: 'danger', message: '图片不能大于5M' })
				return
			}   
			let	params = new FormData()
			params.append('file', file)
			attestationServer.Upload(params).then((res) => {
				this.form[type] = res.data
			}).catch((err) => {
			})
		},
		delImg(type) {
			this.form[type]= ''
		},
		skipAuthorizationView() {
			this.isExplain = true
			// this.$router.push({ name: 'attestation-explain'})
		},
		cancelCity() {},
		confirmCity(e) {
			let str = ''
			e.forEach((item) => {
				str+=item.name
			})
			this.form.workRegion = str
			this.isCityModel = false
		},
		checkIdcard(str) {
			var re = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
			if (re.test(str)) {
				return true
			} else {
				return false
			}
		},
		submitForm() {
			if(!this.isSubmit) return
			if (!this.form.name) return Notify({ type: 'warning', message: '请填写姓名' })
			if (!this.checkIdcard(this.form.idcard)) return Notify({ type: 'warning', message: '请填写正确的身份证号' })
			if (!this.form.companyName) return Notify({ type: 'warning', message: '请填写就职公司' })
			if (!this.form.workRegion) return Notify({ type: 'warning', message: '请填写工作城市' })
			if (!this.form.idcardFrontUrl) return Notify({ type: 'warning', message: '请上传身份证人像面' })
			if (!this.form.idcardBackUrl) return Notify({ type: 'warning', message: '请上传身份证国徽面' })
			if (!this.form.idcardHoldUrl) return Notify({ type: 'warning', message: '请上传手持身份证照片' })
			if (!this.form.otherCertUrl) return Notify({ type: 'warning', message: '请上传名片/工牌/在职证明' })
			this.isSubmit = false
			attestationServer.AddAttestation(this.form).then((res) => {
				this.status = 10
			}).catch(() => {
				this.isSubmit = true
			})
		},
		backFn() {
			this.$router.go(-1)
		},
		base64ToFile(urlData, fileName) {
			let arr = urlData.split(',');
			let mime = arr[0].match(/:(.*?);/)[1];
			let bytes = atob(arr[1]); // 解码base64
			let n = bytes.length
			let ia = new Uint8Array(n);
			while (n--) {
				ia[n] = bytes.charCodeAt(n);
			}
			return new File([ia], fileName, { type: mime });
		},
	},
};
</script>

<style lang="scss">
.attestation {
	padding-top: 46px;
	padding-bottom: 80px;
	.no_over {
		.inform {
			padding: 6px 15px;
			position: relative;
			font-size: 14px;
			color: #3A5EEC;
			background: #CDEFFA;
		}
		.form {
			background: #fff;
			.van-icon {
				img {
					width: 14px;
				}
			}
			.van-cell__title, .van-field__control {
				color: #2b2f3a;
				font-size: 16px;
			}
			.van-field__label {
				width: 68px;
			}
			.van-icon-arrow {
				color: #575E72;
			}
			.upload_card {
				padding: 19px 18px;
				padding-bottom: 0;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				.img_box {
					.img_file {
						position: relative;
						width: 159px;
						height: 93px;
					}
					input {
						position: absolute;
						top: 0;
						left: 0;
						z-index: 2;
						width: 100%;
						height: 100%;
						opacity: 0;
					}
					img {
						width: 159px;
						height: 93px;
					}
					.oss_img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
					.upload_bg {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
					.van-icon {
						position: absolute;
						top: 0;
						right: 0;
						width: 20px;
						height: 20px;
						line-height: 18px;
						padding-left: 6px;
						background-color: rgba(0, 0, 0, 0.7);
						border-radius: 0 0 0 20px;
						color: #fff;
					}
					.tit {
						text-align: center;
						color: #575F72;
						font-size: 15px;
						padding-top: 13px;
						padding-bottom: 22px;
					}
				}
			}
		}
		.authorization {
			font-size: 14px;
			color: #0E88FC;
			padding-left: 19px;
			padding-top: 12px;
		}
		.model_class {
			.van-picker__confirm {
				font-size: 14px;
				color: #2b2f3a;
			}
			.van-hairline--bottom::after {
				border: 0;
			}
			.van-picker__cancel {
				color: #575f72;
			}
		}
		.bottom_btn{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			.van-button--primary {
				width: 100%;
				height: 56px;
				border-radius: 4px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #FFFFFF;
				border-radius: 0;
				background: #3A5EEC;

			}
		}
	}
	.underway {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		img {
			width: 231px;
		}
		p {
			position: absolute;
			bottom: 6px;
			left: 0;
			width: 100%;
			text-align: center;
			font-size: 16px;
			color: #575E72;
		}
	}
	.pass {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 100%;
		text-align: center;
		img {
			width: 157px;
		}
		p {
			color: #2B2F3A;
			font-size: 17px;
			font-weight: bold;
			text-align: center;
			padding-top: 34px;
		}
	}
	.fail {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		text-align: center;
		width: 100%;
		img {
			width: 157px;
		}
		p {
			color: #2B2F3A;
			font-size: 17px;
			font-weight: bold;
			padding-top: 34px;
			width: 80%;
			margin: 0 auto;
		}
		.msg {
			width: 80%;
			display: block;
			margin: 0 auto;
			color: #575F72;
			font-size: 15px;
			padding-top: 4px;
			text-align: left;
			display: flex;
			justify-content: center;
			background: #EFF0F4;
			border-radius: 8px;
			margin-top: 16px;
			padding: 21px 0;
			line-height: 26px;
		}
		.van-button--danger {
			margin-top: 50px;
			width: 217px;
			height: 46px;
			background: #3A5EEC;
			.van-button__text {
				color: #fff;
				padding-top: 0;
				background: transparent;
			}
			
		}

	}

}
</style>


// WEBPACK FOOTER //
// src/views/attestation/Attestation.vue